<i18n>
{
  "en": {
    "messages": {
      "title": "authentication is completed",
      "message": "Instagram authentication is completed. When you log in from next time, please access <br /><b>{url}</b><br />.",
      "okButton": "OK"
    }
  },
  "ja": {
    "messages": {
      "title": "Instagram認証完了",
      "message": "Instagramアカウントの認証が完了しました。<br />次回以降ログインする際には、お送りしたメールアドレスに記載されたURLよりアクセスをお願いします。",
      "okButton": "OK"
    }
  }
}
</i18n>

<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="500" :persistent="true">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $t('messages.title') }}
        </v-card-title>

        <v-card-text xs12 style="word-wrap: break-word;">
          <span v-html="$t('messages.message', { url: location() })"></span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="clickButton">
            {{ $t('messages.okButton') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  methods: {
    clickButton: function() {
      this.$emit('click');
    },
    location: function() {
      return location.href;
    }
  },
  props: {
    title: {
      type: String
    },
    message: {
      type: String
    },
    okButton: {
      type: String
    },
    dialog: {
      type: Boolean
    }
  }
};
</script>
